import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useContext, useEffect, useState } from "react";
import { CategoryContext } from "../../context/categories";
import { TagsContext } from "../../context/tag";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { campaignFetcher } from "../../api/requests";
import { useToaster } from "../../context/toaster";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { formatDuration } from "../../utils/formatDuration";
import { useRef } from "react";
import { AuthContext } from "../../context/auth";

const AddVideoToCampaignForm = ({
  campaignId,
  handleUploadClick,
  loading,
  setLoading,
  progress,
  setProgress,
  onClose,
}) => {
  const [video, setVideo] = useState({
    campaign: campaignId,
    video: "",
    title: "",
    cover: "",
    duration: "",
    description: "",
    cast: "",
    categorys: 0,
    sub_categorys: 0,
    tags: [],
    confirm_to_post: true,
    published_date: new DateObject({
      calendar: persian,
      locale: persian_fa,
    }).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  });

  const [videoDuration, setVideoDuration] = useState(null);
  const { categories, subCategories } = useContext(CategoryContext);
  const { tags } = useContext(TagsContext);
  const [selectedTags, setSelectedTags] = useState([]);
  const [date, setDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa })
  );
  const { addMessage } = useToaster();
  const toastShownRef = useRef(false);
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const handleChange = (name, value) => {
    setVideo({ ...video, [name]: value });
  };

  const handleTagChange = (tagId) => {
    setSelectedTags((prev) => {
      if (prev.includes(tagId)) {
        toastShownRef.current = false;
        return prev.filter((id) => id !== tagId);
      } else if (prev.length < 3) {
        toastShownRef.current = false;
        return [...prev, tagId];
      } else {
        if (!toastShownRef.current) {
          showToast("error", "حداکثر ۳ برچسب قابل انتخاب است.");
          toastShownRef.current = true;
        }
        return prev;
      }
    });
  };

  const handleVideoUpload = (file) => {
    const url = URL.createObjectURL(file);
    const videoEl = document.createElement("video");
    videoEl.src = url;

    videoEl.addEventListener("loadedmetadata", () => {
      setVideoDuration(videoEl.duration);
      URL.revokeObjectURL(url);
    });

    setVideo((prev) => ({ ...prev, video: file }));
  };

  const handleDateChange = (value) => {
    const formatted = value.toString().replace(/\//g, "-");
    setDate(value);
    setVideo({ ...video, published_date: formatted });
  };

  useEffect(() => {
    setVideo((prev) => ({ ...prev, tags: selectedTags }));
  }, [selectedTags]);

  const showToast = (type, text) => {
    addMessage({ id: Math.random().toString(36).substr(2, 9), type, text });
  };

  const handleUpload = async () => {
    if (!video.video || !video.cover || !selectedTags.length || !video.title) {
      showToast("error", "تمام موارد اجباری هستند.");
      return;
    }

    handleUploadClick();
    const formData = new FormData();

    Object.entries(video).forEach(([key, value]) => {
      if (key === "tags") {
        selectedTags.forEach((tag) => {
          formData.append("tags", tag);
        });
      } else if (key === "duration") {
        formData.append("duration", Math.floor(videoDuration));
      } else {
        formData.append(key, value);
      }
    });

    try {
      setLoading(true);
      setProgress(0);
      const res = await campaignFetcher.AddVideoToCampaign(
        formData,
        setProgress
      );
      if (res) {
        setLoading(false);
        setProgress(100);
        setTimeout(() => setProgress(0), 1000);
        showToast("success", "ویدئو با موفقیت بارگزاری شد.");
        if (onClose) onClose();
        history.push(
          `/campaign-videos/?campaign=true&admin=false&publisher=${user?.user_id}`
        );
      }
    } catch (err) {
      setLoading(false);
      setProgress(0);
      showToast(
        "error",
        err.response.data.detail ?? "خطایی رخ داده است، دوباره تلاش کنید."
      );
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        width: "90vw",
        maxHeight: "95rem",
        overflow: "auto",
      }}
    >
      <Row>
        <Col lg={12}>
          <Form>
            <Row>
              <Col lg={12}>
                <Form.Group>
                  <Form.Label>عنوان ویدئو</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="عنوان..."
                    onChange={(e) => handleChange("title", e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col lg={12}>
                <Form.Group>
                  <Form.Label>درباره ویدئو</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="توضیحات..."
                    onChange={(e) =>
                      handleChange("description", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col lg={3}>
                <Form.Group>
                  <Form.Label>ویدئو</Form.Label>
                  <Form.Control
                    type="file"
                    accept="video/*"
                    onChange={(e) => handleVideoUpload(e.target.files[0])}
                  />
                  {videoDuration && (
                    <p className="mt-2">
                      مدت زمان: {formatDuration(Math.floor(videoDuration))}
                    </p>
                  )}
                </Form.Group>
              </Col>

              <Col lg={3}>
                <Form.Group>
                  <Form.Label>پوستر</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleChange("cover", e.target.files[0])}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col lg={4}>
                <Form.Group>
                  <Form.Label>تهیه‌کننده</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("cast", e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <h6 className="mt-3">دسته‌بندی</h6>
                <div
                  style={{
                    maxHeight: 300,
                    overflow: "auto",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {categories?.map((cat) => (
                    <Form.Check
                      style={{ padding: "5px 0px 5px 7px" }}
                      className="catInput"
                      key={cat.id}
                      type="radio"
                      name="categorys"
                      label={cat.name}
                      onChange={() => handleChange("categorys", cat.id)}
                    />
                  ))}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <h6 className="mt-3">زیر دسته</h6>
                <div
                  style={{
                    maxHeight: 300,
                    overflow: "auto",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {subCategories?.map((cat) => (
                    <Form.Check
                      style={{ padding: "5px 0px 5px 7px" }}
                      className="catInput"
                      key={cat.id}
                      type="radio"
                      name="sub_categorys"
                      label={cat.name}
                      onChange={() => handleChange("sub_categorys", cat.id)}
                    />
                  ))}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <h6 className="mt-3">برچسب‌ها (حداکثر ۳ عدد)</h6>
                <div
                  style={{
                    maxHeight: 300,
                    overflow: "auto",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {tags?.results?.map((tag) => (
                    <Form.Check
                      key={tag.id}
                      style={{ padding: "5px 0px 5px 7px" }}
                      className="catInput"
                      type="checkbox"
                      label={tag.name}
                      checked={selectedTags.includes(tag.id)}
                      onChange={() => handleTagChange(tag.id)}
                    />
                  ))}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={4}>
                <Form.Label className="mt-3 ml-2">تاریخ انتشار</Form.Label>
                <DatePicker
                  value={date}
                  onChange={handleDateChange}
                  format="YYYY/MM/DD HH:mm:ss"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                />
              </Col>
            </Row>

            <div className="text-center mt-4">
              <Button variant="outline-primary" onClick={handleUpload}>
                {loading ? "در حال ارسال..." : "ارسال"}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default AddVideoToCampaignForm;
